import { getToken } from '../../services/tokenStore';

// Shared helpers for the W3-R compliance screens.
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const monthLabel = (m?: number | null) => (m && m >= 1 && m <= 12 ? MONTHS[m - 1] : '');
export const money = (v: number | null | undefined) =>
    (v ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const KIND_LABEL: Record<string, string> = {
    PF: 'Provident fund', WPPF_PARTICIPATION: 'WPPF participation fund', WPPF_WELFARE: 'WPPF welfare fund',
    BWWF: 'Workers welfare foundation (BWWF)', OTHER: 'Other',
};
export const TASK_STATUS_LABEL: Record<string, string> = { OPEN: 'Open', DONE: 'Done', NOT_APPLICABLE: 'Not applicable' };

/** The signed-in user's id from the token's userId claim (null when absent or unreadable). */
export const currentUserIdFromToken = (): string | null => {
    try {
        const token = getToken();
        if (!token) return null;
        const payload = JSON.parse(atob(token.split('.')[1]));
        return typeof payload.userId === 'string' ? payload.userId : null;
    } catch {
        return null;
    }
};

/** Document types a filing task can link to (mirrors the backend LINK_TYPES). */
export const LINK_TYPES: { value: string; label: string }[] = [
    { value: 'VAT_PAYMENT', label: 'VAT payment' },
    { value: 'WITHHOLDING_DEPOSIT', label: 'Withholding deposit' },
    { value: 'SALARY_TAX_DEPOSIT', label: 'Salary tax deposit' },
    { value: 'STATUTORY_REMITTANCE', label: 'Statutory remittance' },
];
